// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration of all experiences ID.
 * By convention the experience ID ***MUST*** match exactly (including case) the class name for the experience.
 * NOTE: Keep this list alphabetical
 */
export enum ExperienceIds {
    animator = "Animator",
    autosCard = "AutosCard",
    backgroundGradient = "BackgroundGradient",
    backgroundImageCommon = "BackgroundImageCommon",
    backgroundImageEdge = "BackgroundImageEdge",
    backgroundImageEdgeNext = "BackgroundImageEdgeNext",
    bannerManager = "BannerManager",
    baseHeader = "BaseHeader",
    bingAnswers = "BingAnswers",
    bingCards = "BingCardsExperience",
    bingShopping = "BingShopping",
    bingShoppingLifestyleCard = "BingShoppingLifestyleCard",
    bingShoppingMeStripe = "BingShoppingMeStripe",
    bingMiniShopping = "BingMiniShopping",
    bingWebSSO = "BingWebSSO",
    blowout = "Blowout",
    breakingNews = "BreakingNews",
    cardAction = "CardAction",
    coachmark = "Coachmark",
    clarity = "Clarity",
    comments = "Comments",
    complexContentPreview = "ComplexContentPreview",
    conditionalBanner = "ConditionalBanner",
    contentPreview = "ContentPreview",
    contentProvider = "ContentProvider",
    contentRelated = "ContentRelated",
    contentActionsToolbar = "ContentActionsToolbar",
    contentSharingToolbar = "ContentSharingToolbar",
    cookieWall = "CookieWall",
    covidChatBot = "CovidChatBot",
    displayAds = "DisplayAds",
    dailyBrief = "DailyBrief",
    edgeHeader = "EdgeHeader",
    edgeNextPage = "EdgeNextPage",
    edgePage = "EdgePage",
    edgePageSettings = "PageSettings",
    editorsChoicePromoCard = "EditorsChoicePromoCard",
    electionDelegateCounter = "ElectionDelegateCounter",
    electionEditorsNote = "ElectionEditorsNote",
    electionResultMap = "ElectionResultMap",
    electionResultsCard = "ElectionResultsCard",
    electionVisualizer = "ElectionVisualizer",
    enterpriseComplianceBanner = "EnterpriseComplianceBanner",
    entryPoint = "EntryPoint",
    entryPointEdgeNext = "EntryPointEdgeNext",
    entryPointOffice = "EntryPointOffice",
    eventHubHeroNav = "EventHubHeroNav",
    eventHubPage = "EventHubPage",
    externalContentPreview = "ExternalContentPreview",
    externalNativeAd = "ExternalNativeAd",
    financePage = "FinancePage",
    firstPartyPage = "FirstPartyPage",
    flyoutCard = "FlyoutCard",
    feedbackDialog = "FeedbackDialog",
    feedbackLink = "FeedbackLink",
    feedEdgeNext = "FeedEdgeNext",
    financeCardCommon = "FinanceCardCommon",
    financeMarketCard = "FinanceMarketCard",
    financeIndicesCard = "FinanceIndicesCard",
    financeMarketMoversCard = "FinanceMarketMoversCard",
    financeRecentlyViewedCard = "FinanceRecentlyViewedCard",
    financeWatchlistCard = "FinanceWatchlistCard",
    financeSearchBox = "FinanceSearchBox",
    freMarketSelector = "FreMarketSelector",
    glanceCards = "GlanceCards",
    headerEdgeNext = "HeaderEdgeNext",
    headerNavigationLogo = "HeaderNavigationLogo",
    hiddenContent = "HiddenContent",
    homePage = "HomePage",
    iframe = "IFrame",
    infopane = "Infopane",
    interests = "Interests",
    interestsSearch = "InterestsSearch",
    interestsV1Wrapper = "InterestsV1Wrapper",
    interestsV2 = "InterestsV2",
    languageToggle = "LanguageToggle",
    layoutSwitcher = "LayoutSwitcher",
    legacySharingToolbar = "LegacySharingToolbar",
    localNews = "LocalNews",
    locationContentCard = "LocationContentCard",
    locationSelector = "LocationSelector",
    marketAggregator = "MarketAggregator",
    marketSelector = "MarketSelector",
    meControl = "MeControl",
    meStripe = "MeStripe",
    meetNow = "MeetNow",
    microsoftLogo = "MicrosoftLogo",
    microsoftNewsPage = "MicrosoftNewsPage",
    migrationConsent = "MigrationConsent",
    miniApps = "MiniApps",
    mmxPage = "MMXPage",
    mnsCreatorDashboard = "MnsCreatorDashboard",
    moneyCard = "MoneyCard",
    mobileFeed = "MobileFeed",
    msnSettingMenu = "MsnSettingMenu",
    msRewards = "MsRewards",
    myBriefRiverCard = "MyBriefRiverCard",
    nativeAd = "NativeAd",
    newsbarFeed = "NewsbarFeed",
    notificationBell = "NotificationBell",
    ocvFeedbackData = "OcvFeedbackData",
    office = "Office",
    officeContainer = "OfficeContainer",
    officeDocumentCard = "OfficeDocumentCard",
    officeDocumentsTable = "OfficeDocumentsTable",
    oneFooter = "OneFooter",
    overlay = "Overlay",
    outlookEmailPreview = "OutlookEmailPreview",
    pageRefresh = "PageRefresh",
    partnerWidget = "PartnerWidget",
    pivotContent = "PivotContent",
    pivotContentV2 = "PivotContentV2",
    pivotHover = "PivotHover",
    pivotsNav = "PivotsNav",
    pivotsNavV2 = "PivotsNavV2",
    pollsCard = "PollsCard",
    poweredByLegend = "PoweredbyLegend",
    proactiveCanvas = "ProactiveCanvas",
    promoBanner = "PromoBanner",
    publishersManagement = "PublishersManagement",
    recommendedDocuments = "RecommendedDocuments",
    recommendedSearch = "RecommendedSearch",
    recommendedSearchBelowSearchBox = "RecommendedSearchBelowSearchBox",
    recommendedSites = "RecommendedSites",
    recommendedTopics = "RecommendedTopics",
    relatedSearchesCard = "RelatedSearchesCard",
    rightRail = "RightRail",
    rightRailCarousel = "RightRailCarousel",
    river = "River",
    riverPlaceholder = "RiverPlaceholder",
    searchBoxCommon = "SearchBoxCommon",
    searchBoxEdge = "SearchBoxEdge",
    searchBoxEdgeNext = "SearchBoxEdgeNext",
    searchHistoryCommon = "SearchHistoryCommon",
    searchHistoryEdge = "SearchHistoryEdge",
    searchHistoryEdgenext = "SearchHistoryEdgenext",
    sentimentBarChart = "SentimentBarChart",
    sentimentLineChart = "SentimentLineChart",
    sentimentMap = "SentimentMap",
    sentimentResultCard = "SentimentResultCard",
    serviceWaffle = "ServiceWaffle",
    settingsDialogEdgeNext = "SettingsDialogEdgeNext",
    settingsDialogMsNews = "SettingsDialogMsNews",
    sharedState = "SharedState",
    shopContentCarousel = "ShopContentCarousel",
    shoppingCarousel = "ShoppingCarousel",
    shoppingContentCard = "ShoppingContentCard",
    shoppingSmartList = "ShoppingSmartList",
    showFeed = "ShowFeed",
    showFeedPill = "ShowFeedPill",
    simpleBanner = "SimpleBanner",
    slideShow = "SlideShow",
    smartList = "SmartList",
    social = "Social",
    sportsCard = "SportsCard",
    spotlight = "Spotlight",
    spotlightPreview = "SpotlightPreview",
    starterKit = "StarterKit",
    storyPage = "StoryPage",
    storySnippet = "StorySnippet",
    stripe = "Stripe",
    stripeView = "StripeView",
    superAppPage = "SuperAppHomepage",
    superappHeaderData = "SuperappHeaderData",
    tabbedInfopane = "TabbedInfopane",
    tabbedInfopaneTabPreview = "TabbedInfopaneTabPreview",
    taboolaRiver = "TaboolaRiver",
    tasksCard = "TasksCard",
    topicsHub = "TopicsHub",
    topSites = "TopSites",
    topSitesCommon = "TopSitesCommon",
    topSitesEdge = "TopSitesEdge",
    topSitesEdgeNext = "TopSitesEdgeNext",
    trafficMap = "TrafficMap",
    trafficPage = "TrafficPage",
    trendingNews = "TrendingNews",
    trendingNow = "TrendingNow",
    userInitiatedPageRefresh = "UserInitiatedPageRefresh",
    userProfileDisplay = "UserProfileDisplay",
    videoContent = "VideoContent",
    videoList = "VideoList",
    viewsArticle = "ViewsArticle",
    viewsContentHeader = "ViewsContentHeader",
    viewsGallery = "ViewsGallery",
    viewsPaddles = "ViewsPaddles",
    watchlistCard = "WatchlistCard",
    weatherCard = "WeatherCard",
    weatherData = "WeatherData",
    weatherMap = "WeatherMap",
    weatherOverview = "WeatherOverview",
    weatherPage = "WeatherPage",
    weatherTodayCard = "WeatherTodayCard",
    weatherTodayMini = "WeatherTodayMini",
    welcomeGreeting = "WelcomeGreeting",
    windowsPage = "WindowsPage",
    xfeed = "Xfeed"
}
